import { Card, Col, Row } from 'react-bootstrap';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { TermsAndConditionsTable } from '@components/Product/TermsAndConditions/TermsAndConditionsTable';
import { Page500 } from '@containers/ErrorPages';
import { productApi } from '@reducers/product/product';

export const TermsAndConditions = () => {
  const { data, isLoading, isFetching, isError } =
    productApi.useGetTermsAndConditionsQuery();
  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Header className="bg-didxl text-white">
            Terms and conditions
          </Card.Header>
          <Card.Body>
            <TermsAndConditionsTable data={data} />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
